export default __webpack_public_path__ + "static/media/hero.f5513975.png";